__turbopack_context__.v({
  "carouselShell": "PeopleHero-module-scss-module__EG6-YG__carouselShell",
  "carouselTrack": "PeopleHero-module-scss-module__EG6-YG__carouselTrack",
  "content": "PeopleHero-module-scss-module__EG6-YG__content",
  "peopleHero": "PeopleHero-module-scss-module__EG6-YG__peopleHero",
  "slide": "PeopleHero-module-scss-module__EG6-YG__slide",
  "srOnly": "PeopleHero-module-scss-module__EG6-YG__srOnly",
  "stack-module-0": "PeopleHero-module-scss-module__EG6-YG__stack-module-0",
  "stack-module-1": "PeopleHero-module-scss-module__EG6-YG__stack-module-1",
  "stack-module-10": "PeopleHero-module-scss-module__EG6-YG__stack-module-10",
  "stack-module-11": "PeopleHero-module-scss-module__EG6-YG__stack-module-11",
  "stack-module-12": "PeopleHero-module-scss-module__EG6-YG__stack-module-12",
  "stack-module-13": "PeopleHero-module-scss-module__EG6-YG__stack-module-13",
  "stack-module-14": "PeopleHero-module-scss-module__EG6-YG__stack-module-14",
  "stack-module-15": "PeopleHero-module-scss-module__EG6-YG__stack-module-15",
  "stack-module-16": "PeopleHero-module-scss-module__EG6-YG__stack-module-16",
  "stack-module-17": "PeopleHero-module-scss-module__EG6-YG__stack-module-17",
  "stack-module-18": "PeopleHero-module-scss-module__EG6-YG__stack-module-18",
  "stack-module-19": "PeopleHero-module-scss-module__EG6-YG__stack-module-19",
  "stack-module-2": "PeopleHero-module-scss-module__EG6-YG__stack-module-2",
  "stack-module-20": "PeopleHero-module-scss-module__EG6-YG__stack-module-20",
  "stack-module-3": "PeopleHero-module-scss-module__EG6-YG__stack-module-3",
  "stack-module-4": "PeopleHero-module-scss-module__EG6-YG__stack-module-4",
  "stack-module-5": "PeopleHero-module-scss-module__EG6-YG__stack-module-5",
  "stack-module-6": "PeopleHero-module-scss-module__EG6-YG__stack-module-6",
  "stack-module-7": "PeopleHero-module-scss-module__EG6-YG__stack-module-7",
  "stack-module-8": "PeopleHero-module-scss-module__EG6-YG__stack-module-8",
  "stack-module-9": "PeopleHero-module-scss-module__EG6-YG__stack-module-9",
  "viewport": "PeopleHero-module-scss-module__EG6-YG__viewport",
  "z-base": "PeopleHero-module-scss-module__EG6-YG__z-base",
  "z-content": "PeopleHero-module-scss-module__EG6-YG__z-content",
  "z-footer": "PeopleHero-module-scss-module__EG6-YG__z-footer",
  "z-header": "PeopleHero-module-scss-module__EG6-YG__z-header",
  "z-hero": "PeopleHero-module-scss-module__EG6-YG__z-hero",
  "z-logo": "PeopleHero-module-scss-module__EG6-YG__z-logo",
  "z-logo-effect": "PeopleHero-module-scss-module__EG6-YG__z-logo-effect",
  "z-navigation": "PeopleHero-module-scss-module__EG6-YG__z-navigation",
  "z-sub": "PeopleHero-module-scss-module__EG6-YG__z-sub",
});
